<template>
  <div>
    <vs-table maxHeight="400px" search :data="vesselData">
      <template slot="header">
        <h5 class="mt-2 mb-5">
          {{ $t("ShipmentTable.Shipment") }} : {{ shipmentName }}
        </h5>
      </template>
      <template slot="thead">
        <vs-th>
          {{ $t("ShipmentTable.Id") }}
        </vs-th>
        <vs-th>
          {{ $t("ShipmentTable.TankerName") }}
        </vs-th>
        <vs-th>
          {{ $t("ShipmentTable.TransferVolume") }}
          <!-- {{ $t("ShipmentTable.TransferVolume")}} ( {{ ($t('Liter')) }} ) -->
        </vs-th>
        <vs-th>
          {{ $t("ShipmentTable.TransferStart") }}
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{ indextr + 1 }}
          </vs-td>

          <vs-td>
            {{ data[indextr].tanker_name }}
          </vs-td>

          <vs-td :data="data[indextr].volume">
            {{ formatNumber(data[indextr].volume) }}
          </vs-td>

          <vs-td :data="data[indextr].start_at">
            {{ setDateFormat(data[indextr].start_at) }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import _ from "lodash";
import { formatNumber } from "@/utils/index";

export default {
  name: "vesselTable",
  data() {
    return {
        vesselData : [],
        formatNumber
    };
  },
  mounted() {
    // console.log(this.transferLogsByConfig);
    this.setvesselData();
  },
  computed: {
    ...mapState({
      shipmentName: (state) => state.tankerData.tankerName,
      transferLogsByConfig: (state) => state.mpVesselData.transferLogsByConfig,
      tankers: (state) => state.mpTankerData.mpTankerAll,
    }),
  },
  watch: {
    shipmentName(val, oldval) {
      if (!_.isEqual(val, oldval)) {
        this.changeData(val);
      }
    },
    transferLogsByConfig(val) {
      if (val.length > 0) {
        this.setvesselData();
      }
    },
  },
  methods: {
    changeData(val) {
      this.$store.dispatch("setTankerName", val);
    },
    setDateFormat(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date)
          .add(543, "years")
          .format("DD/MM/YYYY HH:mm");
        return newDate;
      }
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    setvesselData() {
      const setUpData = _.filter(this.transferLogsByConfig, "tanker_id", null);
      this.vesselData = setUpData.map((a) => {
        const tanker_name = _.get(
          _.find(this.tankers, { id: a.tanker_id }),
          "name"
        );
        return {
          ...a,
          tanker_name,
        };
      });
    //   console.log(this.vesselData);
    },
  },
};
</script>

<style>
.tableship {
  height: 100%;
}
</style>
